import React from "react";
import { Flex } from "@chakra-ui/react";
import { BrandedLogo } from "./BrandedLogo";

export const LoginBrandingLogo: React.FC = () => {
  return (
    <Flex align="center" gap="12.8px">
      <BrandedLogo variant="full" />
    </Flex>
  );
};
